import {Provider} from 'domain/usecases/private/authorizations/get-providers-list';
import {formatCompleteAddress} from 'presentation/utils';

export const formatProviderAddress = (provider: Provider) => {
	if (!provider) return '';

	const {nmEndereco, nmCidade, cdUF} = provider;

	const cleanedAddress = (nmEndereco || '')
		.split(',')
		.map(part => part.trim())
		.filter(Boolean)
		.join(' ');

	const cidadeUf = [nmCidade, cdUF].filter(Boolean).join('/');
	const final = cidadeUf ? `${cleanedAddress} - ${cidadeUf}` : cleanedAddress;

	return formatCompleteAddress(final);
};
